import { Report, HeartParams, BeaconOptions, ApiParams } from '@tencent/dz-report';
import { generateUuid } from '@tencent/dz-models';
import contentExposure, { ContentExposure } from './ContentExposure';
import { config } from 'src/config';
import Cookies from 'js-cookie';

const fmcConGuestID = Cookies.get('fmc_con_guest_id');


class ReportExtension extends Report {
  public contentExposure: ContentExposure = contentExposure;

  public heart(params: Partial<HeartParams>, beaconOptions?: BeaconOptions) {
    const exposureInfo = JSON.stringify(this.contentExposure.getElementsInViewport());
    const timestamp = new Date().getTime();
    const nextParams = {
      timestamp,
      beat_time: new Date().toLocaleString(),
      // heart_beat_type: 4, // 1-心跳；2-进入页面；3-会话创建；4-会话关闭；5-页面关闭
      page_activate: window.pageActivate,
      page_duration: window.pageDuration,
      exposure_info: exposureInfo,
      heart_beat_interval: 0,
      chat_activate: window.chatActivate,
      navigation_start_cost: timestamp - window.pageStartTime,
      ...params,
    };

    super.heart(nextParams as HeartParams, beaconOptions);
  }

  public api(params: Partial<ApiParams>, beaconOptions?: BeaconOptions) {
    const nextParams = {
      trace_id: generateUuid(),
      account_id: window.FMC_HOST.consult.u_id,
      consult_id: window.FMC_HOST.consult.component_id,
      consult_url: window.location.href,
      guest_id: fmcConGuestID,
      ...params,
    };

    super.api(nextParams as ApiParams, beaconOptions);
  }
}


export const report = new ReportExtension(window.beacon, { debug: config.debug.beacon });
